import React from 'react'
import type { ICellRendererParams } from 'ag-grid-community'
import { MaterialIcon } from '@gravitate-js/excalibrr'
import { Popover, Badge } from 'antd'
import type { Match } from '../../../../../../api/useSupplierReconciliation/types/match'

export function WarningsCellRenderer({ data, context }: ICellRendererParams<Match>) {
  if (!data?.warnings?.length) return null

  const displayWarnings = data.warnings.filter((w) => {
    // Filter out movement_validation warnings (they show in BOL tooltips instead)
    if (w.type === 'movement_validation') return false

    // Filter out delivery_reconciliation warnings (they show in BOL styling/tooltips instead)
    if (w.type === 'delivery_reconciliation') return false

    return true
  })
  const totalCount = displayWarnings.length

  if (totalCount === 0) return null

  const warningContent = (
    <div style={{ maxWidth: 300 }}>
      <div style={{ fontWeight: 600, marginBottom: 8 }}>Warning Details ({totalCount})</div>
      {displayWarnings.map((warning, index) => (
        <div
          key={warning.id || `warning-${index}-${warning.type}`}
          style={{ marginBottom: 8, paddingBottom: 8, borderBottom: '1px solid var(--theme-separator)' }}
        >
          <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--theme-warning)' }}>
            {warning.type.replace(/^by_/, '').replace(/_/g, ' ').toUpperCase()}
          </div>
          <div style={{ fontSize: 11, color: 'var(--theme-text-secondary)', marginBottom: 4 }}>{warning.message}</div>
          <div style={{ fontSize: 11, color: 'var(--theme-text-hint)' }}>
            Variance: {warning.variance?.toFixed(2) || 'N/A'}
            {warning.unit} | Threshold: {warning.threshold?.toFixed(2) || 'N/A'}
            {warning.unit}
          </div>
        </div>
      ))}
    </div>
  )

  return (
    <Popover content={warningContent} title={null} trigger='hover' placement='top'>
      <div style={{ cursor: 'pointer', overflow: 'visible' }}>
        <Badge count={totalCount} style={{ backgroundColor: 'var(--theme-warning)' }}>
          <MaterialIcon icon='warning' style={{ color: 'var(--theme-warning)', fontSize: 18 }} />
        </Badge>
      </div>
    </Popover>
  )
}
